(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Frequency', Frequency);

    Frequency.$inject = ['$resource'];

    function Frequency ($resource) {
        var resourceUrl =  'api/frequencies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
